import React from "react";
import Home from "./Home/Home";
import About from "./About/About";
import Experience from "./Experience/Experience";
import Projects from "./Projects/Projects";
import Education from "./Education/Education";

function Main() {
  return (
    <>
      <Home />
      <About />
      <Experience />
      <Projects />
      <Education />
    </>
  );
}

export default Main;
